<div class="menu-history-modal">
  <h4>{{ 'MENU.EVENTS_TITLE' | translate }}</h4>

  <table
    mat-table
    [dataSource]="dataSource"
    multiTemplateDataRows>

    <ng-container
        *ngFor="let column of columnsToDisplay"
        matColumnDef="{{ column }}">
        <th mat-header-cell *matHeaderCellDef>{{ getColumnHeader(column) }}</th>
        <td  class="cell" mat-cell *matCellDef="let element">
            <div [ngSwitch]="column">
              <ng-template ngSwitchCase="createdAt">
                {{element.createdAt | utcToLocal: this.dateFormat}}
              </ng-template>

              <ng-template ngSwitchDefault>
                  {{ element[column] }}
              </ng-template>

            </div>

        </td>
    </ng-container>

    <tr
        mat-header-row
        *matHeaderRowDef="columnsToDisplay; sticky: true">
    </tr>
    <tr
        mat-row
        *matRowDef="let element; columns: columnsToDisplay">
    </tr>
</table>
<mat-paginator [pageSizeOptions]="[100, 200, 500]"
               [pageIndex]="this.pageIndex"
               [pageSize]="this.pageSize"
               [length]="this.totalItems"
               (page)="this.handlePageEventAsync($event)"
               showFirstLastButtons>
</mat-paginator>
</div>
